"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _services = require("../../../services");
var _r10SourceLibrary = require("r10-source-library");
var _constants = require("../../../utils/constants");
var _SelectInput = _interopRequireDefault(require("./SelectInput"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const CenteringWrapper = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const DiscountedPrice = _styledComponents.default.div`
  min-height: 26px;
`;
const BroadbandCardContent = _ref => {
  let {
    setSelectedProduct,
    selectOptions,
    selectedProduct,
    onSelect
  } = _ref;
  const {
    paymentOption,
    productId
  } = selectedProduct;
  const paymentTermText = (paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.priceType) === _constants.PRICE_TYPES.RECURRING ? _services.Services.locale.localeString(`Comparison.${paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.term.unit}`) : '';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 3,
      bottom: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_SelectInput.default, {
    productId: productId,
    selectOptions: selectOptions,
    onChangeHandle: setSelectedProduct
  })))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(CenteringWrapper, {
    id: "broadband-card"
  }, (paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.price) && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    id: "broadband-price",
    size: 2,
    weight: 3
  }, `${paymentOption.price} ${paymentTermText}`)))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(DiscountedPrice, null, (paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.previousPrice) && /*#__PURE__*/_react.default.createElement("span", {
    id: "broadband-previous-price",
    style: {
      color: '#0D0D0D',
      textDecoration: 'line-through'
    }
  }, `${paymentOption.previousPrice} ${paymentTermText}`))))))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 3,
      bottom: 3
    }
  }, /*#__PURE__*/_react.default.createElement(CenteringWrapper, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
    appearance: "secondary",
    text: _services.Services.locale.localeString('Comparison.BroadbandButtonText'),
    width: "full",
    onClick: () => {
      onSelect(productId);
    },
    id: "broadband-select-btn"
  }))))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: "center",
    marginTop: 2
  }, /*#__PURE__*/_react.default.createElement(DiscountedPrice, null, paymentOption.term.duration && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    id: "broadband-duration"
  }, _services.Services.locale.localeString('Comparison.For'), " ", paymentOption.term.duration, ' ', _services.Services.locale.localeString('Comparison.Months')))));
};
var _default = BroadbandCardContent;
exports.default = _default;